import { useState, useEffect } from "react"
import {
    SubmitBtn,
    ActionSection,
    SideCancelBtn,
    ModalHeader,
} from "../Styles/InputStyles"
import { MdClose } from "react-icons/md"
import tw from "tailwind-styled-components"
import "react-dropdown/style.css"
import { GoSearch } from "react-icons/go"
import SelectCategoryModal from "./SelectCategoryModal"
import { toast } from "react-toastify"

const FilterModal = ({
    categories,
    onApplyFilter,
    handleClose,
    handleClear,
    selectedCategory,
    setSelectedCategory
}) => {
    const [height, setHeight] = useState(window.innerHeight);
    const [showCategoryModal, setShowCategoryModal] = useState(false);

    const handleSelectedCategory = (selectedOption) => {
        setSelectedCategory(selectedOption)
    }

    const handleCategorySave = (category) => {
        handleSelectedCategory(category)
        setShowCategoryModal(false)
    }

    const handleApplyFilter = () => {
        if (selectedCategory)
            onApplyFilter(selectedCategory.value, selectedCategory.label);
        else
            toast.error("Please select at least one filter before applying.");
    };

    useEffect(() => {
        const handleResize = () => {
            setHeight(window.innerHeight)
        }
        window.addEventListener("resize", handleResize)
        handleResize()
        return () => {
            window.removeEventListener("resize", handleResize)
        }
    }, [])

    return (
        <Container style={{ height: `${height}px`, overflow: "auto", WebkitOverflowScrolling: "touch" }}>
            <ModalHeader>
                <h1 className="text-lg font-medium text-white">Filters</h1>
                <button onClick={handleClose}>
                    <MdClose color="white" size={24} />
                </button>
            </ModalHeader>
            <div className="p-4 relative">
                <FilterTitle>{"Search By Category"}</FilterTitle>

                <div className="relative mt-2">
                    <input
                        type="text"
                        placeholder="Search categories..."
                        //value={searchText}
                        onClick={(e) => setShowCategoryModal(true)}
                        className="w-full px-8 h-12 py-2 border border-gray-200 rounded-md focus:outline-none focus:border-primary-color text-gray-800 placeholder-gray-300"
                    />
                    <div className="absolute left-3 top-1/2 transform -translate-y-1/2">
                        <GoSearch className="w-4 h-4 text-gray-400" />
                    </div>
                </div>
            </div>

            <div className="custom-scrollbar flex h-full flex-col justify-between px-4">
                {/* Selected Tags */}
                {selectedCategory && (
                    <div className="flex flex-wrap gap-2 mt-3">
                        <div className="flex items-center bg-primary-color/10 text-primary-color 
                      px-3 py-1 rounded-full text-sm">
                            {selectedCategory.label}

                            <button
                                onClick={() => setSelectedCategory(null)}
                                className="ml-2 text-primary-color hover:text-red-500"
                            >
                                <MdClose size={16} />
                            </button>
                        </div>
                    </div>
                )}
                <ActionSection>
                    <SideCancelBtn type="button" onClick={handleClear}>
                        {selectedCategory ? "Clear" : "Cancel"}
                    </SideCancelBtn>
                    <SubmitBtn type="submit" onClick={handleApplyFilter}>
                        Apply Filter
                    </SubmitBtn>
                </ActionSection>
            </div>
            <SelectCategoryModal
                isOpen={showCategoryModal}
                onClose={() => setShowCategoryModal(false)}
                onSelect={handleCategorySave}
                categories={categories}
                selectedCategory={selectedCategory}
            />
        </Container>
    )
}

const Container = tw.div`bg-white w-full h-full flex flex-col relative`
const Header = tw.div`flex items-center justify-between bg-primary-color py-4 px-4`
const FilterTitle = tw.h3`text-md font-medium text-gray-800 mb-2`;

export default FilterModal